import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-full-image',
  templateUrl: './full-image.component.html',
  styleUrls: ['./full-image.component.scss'],
})
export class FullImageComponent  implements OnInit {
  fullImage: string = '';
  fileUploadInputs = ['image'];

  @Input() images: any[] = [];
  @Input() blocIndex: number = 0;
  @Output() inputChange = new EventEmitter<{
    fullImage: string;
  }>();
  constructor() {}

  ngOnInit() {
    const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    if (!formattedActualite.articleBlocks) {
      return;
    }
    const block = formattedActualite.articleBlocks.find((block: any) => block.type === 2);
    if (block) {
      this.fullImage = block.content.fullImage;
      this.inputChange.emit({
        fullImage: this.fullImage,
      });
    }
  }

  onInputChange(event?: any) {
    this.fullImage = event.files[0];
    this.inputChange.emit({
      fullImage: this.fullImage,
    });
  }
}
